module.exports = __webpack_public_path__ + "static/media/25_CalTrain - San Francisco.a1f57363.jpg";